import { getDefaultValues } from '@pages/DiagramsCreateOrEdit/helpers'
import { ConfigBarChartForm } from '@pages/DiagramsCreateOrEdit/types'

import { axisXOptions, FORMATS_DATE_OPTIONS, incrementOptions, periodOptions } from '@constants'
import { ViewShortDTO } from '@types'

import { BarChartResponseType } from '../../../types/api/barChart.api'

export const convertDataToRequestData = (data: ConfigBarChartForm) => {
  return {
    ...data,
    timeline: {
      id: data.timeline.id,
      axisX: data.timeline.axisX.id,
      diagramId: data.id,
      dateRange: {
        from: data.timeline.dateRange[0],
        till: data.timeline.dateRange[1],
      },
      formatDate: data.timeline.formatDate.id,
      period: data.timeline.period.id,
      timeIncrement: data.timeline.timeIncrement.id,
      hideFilters: data.timeline.hideFilters,
    },
    series: data.timeline.series.map(singleSeries => ({
      id: singleSeries.id,
      order: singleSeries.order,
      timelineId: data.timeline.id,
      dateRange: singleSeries.dateRange,
      title: singleSeries.title,
    })),
  }
}

export const convertResponseToData = (
  data: BarChartResponseType,
  views: ViewShortDTO[]
): ConfigBarChartForm => {
  const defaultValues = getDefaultValues()

  return {
    ...data,
    timeline: data.timeline
      ? {
          ...data.timeline,
          axisX:
            axisXOptions.find(option => option.id === data.timeline.axisX) ||
            defaultValues.timeline.axisX,
          period:
            periodOptions.find(option => option.id === data.timeline.period) ||
            defaultValues.timeline.period,
          timeIncrement:
            incrementOptions.find(option => option.id === data.timeline.timeIncrement) ||
            defaultValues.timeline.timeIncrement,
          dateRange: data.timeline.dateRange
            ? [data.timeline.dateRange.from, data.timeline.dateRange.till]
            : defaultValues.timeline.dateRange,
          formatDate:
            FORMATS_DATE_OPTIONS.find(option => option.id === data.timeline.formatDate) ||
            defaultValues.timeline.formatDate,
          series: data.timeline.series.toSorted((a, b) => a.order - b.order),
        }
      : defaultValues.timeline,
    // columns: data.columns?.length
    //   ? data.columns.map(column => {
    //       const colorParameter = column.parameters.find(parameter => parameter.paramKey === 'color')
    //
    //       return {
    //         ...column,
    //         parameters: {
    //           color: colorParameter?.param,
    //           colorId: colorParameter?.id,
    //         },
    //       }
    //     })
    //   : defaultValues.columns,
  }
}
